<template>
  <div id="app" class="app-root" :class="[locale]">
    <layout-header v-if="!noHeader" @setLang="l => locale = l"></layout-header>
    <div id="scroll-box"></div>
    <div class="app-container" :style="{ position: modal.action && !isDialogLoading ? 'relative' : 'relative' }">
      <div class="app-pages" :class="{ 'no-header': noHeader }">
        <!-- <div class="app-background" :class="{ filter: !isMainPage, cover: isMainPage }" :style="{ background: '#eeeeee', backgroundSize: 'cover' }"></div> -->
        <div class="max-width" v-if="!isMainPage" :class="{ 'large-page': isLargePage }" :style="{ minHeight: minHeight, display: isMainPage ? 'flex' : 'block', 'align-items': 'center' }">
          <div class="view-container">
            <div class="view-field responsitive-color transparent-transparent">
              <keep-alive :include="routeReset ? [] : ['caseList', 'datasetList']">
                <router-view :minHeight="minHeight" />
              </keep-alive>
            </div>
          </div>
        </div>
        <div class="app-main-container" v-else>
          <keep-alive :include="[]">
            <router-view :minHeight="minHeight" />
          </keep-alive>
        </div>
        <!-- <layout-footer></layout-footer> -->
      </div>
    </div>
    <div class="modal-container">
      <modal v-if="modal.action" :style="!isDialogLoading ? {} : { display: 'none' }" :width="modal.width" :height="modal.height" :customStyles="modal.customStyles" :maskClose="modal.maskClose" @hide="() => {
        modal.callback && modal.callback()
        setModalAction({})
      }">
        <component :is="modal.action" :param="modal.param" @changeModal="(option, param) => {
          modal.callback && modal.callback(param)
          this.setModalAction(option || {})
        }"></component>
      </modal>
      <modal v-if="modal2.action" :style="!isDialogLoading ? {} : { display: 'none' }" :width="modal2.width" :height="modal2.height" :customStyles="modal2.customStyles" :maskClose="modal2.maskClose" @hide="() => {
        modal2.callback && modal2.callback()
        setModal2Action({})
      }">
        <component :is="modal2.action" :param="modal2.param" @changeModal="(option, param) => {
          modal2.callback && modal2.callback(param)
          this.setModal2Action(option || {})
        }"></component>
      </modal>
    </div>
    <layoutFileUpload v-if="isLogin"></layoutFileUpload>
    <layoutToast></layoutToast>
    <layoutBorCor></layoutBorCor>
    <layoutLoading v-if="isLoading"></layoutLoading>
    <layoutUploading v-if="isUploading !== undefined" :content="isUploading"></layoutUploading>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { getUserToken, getUserSettings } from './api'
import layoutHeader from './components/layout/header'
import layoutFooter from './components/layout/footer'
import layoutToast from './components/tool/toast'
import layoutBorCor from './components/layout/borCor'
import layoutLoading from './components/layout/loading'
import layoutUploading from './components/layout/uploading'
import layoutFileUpload from './components/layout/fileUpload'
import responsitive from './mixins/responsitive'
import toastMethods from './mixins/toastMethods'
import loginData from './mixins/loginData'
import locale from './mixins/locale.vue'
import licenseManager from './mixins/licenseManager.vue'
// modals
import modal from './components/dialog/container.vue'
import userConfirm from './components/dialog/userConfirm.vue'
import editWorkgroupMember from './components/dialog/editWorkgroupMember.vue'
import editWorkgroupCase from './components/dialog/editWorkgroupCase.vue'
import editWorkgroupStage from './components/dialog/editWorkgroupStage.vue'
import intractableDiseaseSelect from './components/dialog/intractableDiseaseSelect.vue'
import genePanelInfo from './components/dialog/genePanelInfo.vue'
import editPanel from './components/dialog/editPanel.vue'
import addToPanel from './components/dialog/addToPanel.vue'
import genePanelQuickSelection from './components/dialog/genePanelQuickSelection.vue'
import genePanelDataSelect from './components/dialog/genePanelDataSelect.vue'
import genePanelConfirm from './components/dialog/genePanelConfirm.vue'
import selectDataset from './components/dialog/selectDataset.vue'
import fileCloud from './components/dialog/fileCloud.vue'
import caseConfirm from './components/dialog/caseConfirm.vue'
import caseEdit from './components/dialog/caseEdit.vue'
import projectEdit from './components/dialog/projectEdit.vue'
import caseFile from './components/dialog/caseFile.vue'
import caseAnalysisVersion from './components/dialog/caseAnalysisVersion.vue'
import caseDetailSVFilter from './components/dialog/caseDetailSVFilter.vue'
import caseDetailGenePedigree from './components/dialog/caseDetailGenePedigree.vue'
import caseDetailGeneVariantDatabase from './components/dialog/caseDetailGeneVariantDatabase.vue'
import caseDetailGeneQuality from './components/dialog/caseDetailGeneQuality.vue'
import caseDetailGenePreview from './components/dialog/caseDetailGenePreview.vue'
import caseDetailGeneACMG from './components/dialog/caseDetailGeneACMG.vue'
import caseDetailRegionGene from './components/dialog/caseDetailRegionGene.vue'
import caseDetailRegionQuality from './components/dialog/caseDetailRegionQuality.vue'
import caseDetailRegionVariant from './components/dialog/caseDetailRegionVariant.vue'
import caseDetailRegionPublication from './components/dialog/caseDetailRegionPublication.vue'
import caseDetailRegionCaller from './components/dialog/caseDetailRegionCaller.vue'
import editChapter from './components/dialog/editChapter.vue'
import addVariantToChapter from './components/dialog/addVariantToChapter.vue'
import editReportVariant from './components/dialog/editReportVariant.vue'
import editCNVToChapter from './components/dialog/editCNVToChapter.vue'
import editReportCNV from './components/dialog/editReportCNV.vue'
import userAvatar from './components/dialog/userAvatar.vue'
import imageCropper from './components/dialog/imageCropper.vue'
import datasetSelectCase from './components/dialog/datasetSelectCase.vue'
import datasetDetail from './components/dialog/datasetDetail.vue'
import datasetEdit from './components/dialog/datasetEdit.vue'
import datasetShareEdit from './components/dialog/datasetShareEdit.vue'
import datasetDeleteConfirm from './components/dialog/datasetDeleteConfirm.vue'
import datasetArchiveConfirm from './components/dialog/datasetArchiveConfirm.vue'
import datasetInvitationConfirm from './components/dialog/datasetInvitationConfirm.vue'
import chatbot from './components/dialog/chatbot.vue'
import addLicenseID from './components/dialog/addLicenseID.vue'
import toast from './components/dialog/toast.vue'
import { parseUserSetting } from './constants/global/data'

require('font-awesome-sass-loader')

export default {
  name: 'app',
  components: {
    layoutHeader,
    layoutFooter,
    layoutToast,
    layoutBorCor,
    layoutLoading,
    layoutUploading,
    layoutFileUpload,
    // modals
    modal,
    userConfirm,
    editWorkgroupMember,
    editWorkgroupCase,
    editWorkgroupStage,
    intractableDiseaseSelect,
    genePanelInfo,
    editPanel,
    addToPanel,
    genePanelQuickSelection,
    genePanelDataSelect,
    genePanelConfirm,
    selectDataset,
    fileCloud,
    caseConfirm,
    caseEdit,
    projectEdit,
    caseFile,
    caseAnalysisVersion,
    caseDetailSVFilter,
    caseDetailGenePedigree,
    caseDetailGeneVariantDatabase,
    caseDetailGeneQuality,
    caseDetailGenePreview,
    caseDetailGeneACMG,
    caseDetailRegionGene,
    caseDetailRegionQuality,
    caseDetailRegionVariant,
    caseDetailRegionPublication,
    caseDetailRegionCaller,
    editChapter,
    addVariantToChapter,
    editReportVariant,
    editCNVToChapter,
    editReportCNV,
    userAvatar,
    imageCropper,
    datasetSelectCase,
    datasetDetail,
    datasetEdit,
    datasetShareEdit,
    datasetDeleteConfirm,
    datasetArchiveConfirm,
    datasetInvitationConfirm,
    chatbot,
    addLicenseID,
    toast
  },
  mixins: [
    responsitive,
    loginData,
    toastMethods,
    locale,
    licenseManager
  ],
  data () {
    return {
      userAgent: '',
      minHeight: '300px'
    }
  },
  watch: {
    '$route' () {
      const { body } = document
      body.scroll(0, 0)
      this.setModalAction({})
      this.setModal2Action({})
      window.dispatchEvent(new Event('resize'))
      if (this.initial !== null) {
        this.setLoadingAction(true)
        this.validateRoute(this.isLogin)
      }
      setTimeout(() => this.setRouteResetAction(false))
    },
    async 'isLogin' (n, o) {
      if (o !== null) {
        this.setLoadingAction(true)
        await this.preFetchDataGuest()
        if (n) {
          await this.preFetchData()
          this.setServerLang()
        } else {
          this.setUnloadAlertAction()
        }
        this.appInitialAction(n)
        this.setLoadingAction(false)
      }
    },
    'unloadAlert' (nv) {
      if (nv) {
        window.document.body.onbeforeunload = function () { return '' }
      } else {
        window.document.body.onbeforeunload = null
      }
    }
  },
  computed: {
    ...mapGetters([
      'normalPage',
      'userPage',
      'adminPage',
      'initial',
      'isLogin',
      'isLoading',
      'isDialogLoading',
      'isUploading',
      'routeReset',
      'modal',
      'modal2',
      'unloadAlert'
    ]),
    isMainPage () {
      return this.$route.name && [
        // normal page
        'main',
        'deviceAlert',
        'forget',
        'reset',
        'register',
        'active',
        'genePanel',
        'phenotypeDisease',
        'coverageRate',
        // user page
        'user',
        'phenotype',
        'config',
        'point',
        'systemInfo',
        'datasetInvitationConfirm',
        //
        ''
      ].includes(this.$route.name)
    },
    isLargePage () {
      return this.$route.name && [
        // normal page
        // user page
        //
        ''
      ].includes(this.$route.name)
    },
    noHeader () {
      return this.$route.name && ['main', ''].includes(this.$route.name)
    }
  },
  created () {
    this.userAgent = navigator.userAgent
    this.setLocale()
    this.setModalAction({})
    this.setModal2Action({})
    this.setLoadingAction(true)
    const validateLogin = () => {
      if (this.$route.name) {
        this.validateLogin()
      } else {
        setTimeout(() => validateLogin(), 100)
      }
    }
    validateLogin()
  },
  beforeMount () {
    const { body } = document
    const handler = () => {
      if (!document.hidden) {
        let rect = body.getBoundingClientRect()
        let headerHeight = this.noHeader ? 0 : 60
        let footerHeight = 0
        let height = rect.height - headerHeight - footerHeight + 0
        this.minHeight = height + 'px'
      }
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
  },
  mounted () {
    window.addEventListener('scroll', () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      let offsetHeight = document.documentElement.offsetHeight || document.body.offsetHeight
      this.setScrollStateAction({
        top: scrollTop,
        height: scrollHeight - offsetHeight
      })
    })
  },
  methods: {
    ...mapActions([
      'appInitialAction',
      'setLoadingAction',
      'setDialogLoadingAction',
      'clearLoadingAction',
      'clearDialogLoadingAction',
      'setModalAction',
      'setModal2Action',
      'setUnloadAlertAction',
      'setScrollStateAction',
      'setRouteResetAction',
      // global
      'setUserSettingAction',
      'setUserAvatarAction'
    ]),
    setLocale () {
      const langMap = l => {
        if (!l) return null
        l = l.toLowerCase()
        // if (l === 'zh-cn') return 'tc'
        // if (l.startsWith('zh')) return 'tc'
        if (l === 'ja-JP') return 'ja'
        if (l.startsWith('ja')) return 'ja'
        return 'en'
      }
      let locale = localStorage.getItem('locale')
      if (!this.languageOptions.map(option => option.value).includes(locale)) {
        locale = langMap(window.navigator.language || navigator.userLanguage) || 'en'
      }
      this.setLang(locale)
    },
    async preFetchDataGuest () {
    },
    async preFetchData () {
      await this.fetchUserSettings()
      await this.setLicenseStatus()
    },
    async fetchUserSettings () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getUserSettings(config)
        let userSettings = response.data.data
        userSettings = parseUserSetting(userSettings || {})
        this.setUserSettingAction(userSettings)
      } catch (error) {
        throw error
      }
    },
    async validateLogin () {
      let userInfo = this.$ls.get('userInfo') || {}
      await this.preFetchDataGuest()
      // await postLandingVisits('webclient')
      if (userInfo['access_token']) {
        await this.getUserByToken(userInfo)
      } else {
        this.setUserData(null)
        this.appInitialAction(false)
        this.validateRoute(false)
      }
    },
    async getUserByToken (data) {
      try {
        let response = await getUserToken(data)
        await this.preFetchData()
        let user = response.data.user || response.data.data || { role: {} }
        this.setUserData(response, data)
        this.appInitialAction(true)
        this.validateRoute(true, user.role, ['supervisor'].includes(user.role))
      } catch (error) {
        this.setUserData(null)
        this.appInitialAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        this.validateRoute(false)
      }
    },
    validateRoute (isLogin, role, admin) {
      let array = []
      if (isLogin) {
        switch (role) {
          default: {
            array = _.union(this.userPage, this.normalPage)
          }
        }
      } else {
        array = this.normalPage
      }
      if (admin) {
        array = _.union(array, this.adminPage)
      }
      this.validateRole(isLogin, array)
    },
    validateRole (isLogin, pages) {
      let routeName = this.$route.name
      if (routeName && !_.includes(pages, routeName)) {
        this.addToast('error', isLogin ? this.$t('COMMON.toast.___noPermission') : this.$t('COMMON.toast.___pleaseLogin'))
        this.$router.push(isLogin ? { name: 'main' } : { name: 'main', query: { redirect: this.$route.fullPath } })
        this.setLoadingAction(false)
      } else {
        if (isLogin && _.includes(this.normalPage, routeName) && !['active', 'datasetInvitationConfirm', 'genePanel', 'phenotypeDisease', 'coverageRate', 'datasetDetail'].includes(routeName)) {
          this.$router.push({ name: 'caseList' })
        }
        this.setLoadingAction(false)
      }
    }
  }
}
</script>

<style lang="sass">
@import sass/style

/* quill global */
.ql-container
  overflow: hidden !important
  .ql-editor
    font-family: 'Noto Sans TC' !important
    font-size: 1rem !important
    span
      line-height: 1.6 !important
    img
      max-width: 100% !important

/* quill font */
// noto-sans-tc
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=noto-sans-tc]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=noto-sans-tc]::before
  content: 'Noto Sans'
  font-family: 'Noto Sans TC'
.ql-font-noto-sans-tc
  font-family: 'Noto Sans TC'

/* quill size */
// h5
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=h5]::before
  content: 'h5'
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=h5]::before
  content: 'h5'
  font-size: 0.75rem
.ql-size-h5
  font-size: 0.75rem

// h4
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=h4]::before
  content: 'h4'
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=h4]::before
  content: 'h4'
  font-size: 1.2rem
.ql-size-h4
  font-size: 1.2rem

// h3
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=h3]::before
  content: 'h3'
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=h3]::before
  content: 'h3'
  font-size: 1.5rem
.ql-size-h3
  font-size: 1.5rem

// h2
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=h2]::before
  content: 'h2'
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=h2]::before
  content: 'h2'
  font-size: 2.5rem
.ql-size-h2
  font-size: 2.5rem

// h1
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=h1]::before
  content: 'h1'
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=h1]::before
  content: 'h1'
  font-size: 4rem
.ql-size-h1
  font-size: 4rem
</style>



// WEBPACK FOOTER //
// src/App.vue